export default __webpack_public_path__ + "static/media/Aneomi-2.5900a1c8.png";